// 数量欄の値に合わせて、価格表の該当する行を光らせる。
// 金額の再計算はしない(実額はカートで確定するため)。表の行を指すだけなので、
// 割引の設定と表示がずれることがない。
//
// テーマエディタはセクションを innerHTML で描き直すため、カスタム要素で書く。
class PriceTableHighlight extends HTMLElement {
  connectedCallback() {
    this.rows = [...this.querySelectorAll('tbody tr[data-qty-min]')];
    if (this.rows.length === 0) return;

    this.onInput = () => this.update();
    this.bind();
    this.update();
  }

  disconnectedCallback() {
    this.unbind();
  }

  // 数量欄はフォームの外にあることがあるので、ページ全体から探す
  get input() {
    return document.querySelector('input[name="quantity"]');
  }

  bind() {
    const input = this.input;
    if (!input) return;
    this.watched = input;
    input.addEventListener('input', this.onInput);
    input.addEventListener('change', this.onInput);
    // ± ボタンは値をスクリプトから書き換えるため、click も拾う
    const wrap = input.closest('quantity-input') || input.parentElement;
    if (wrap) {
      this.watchedWrap = wrap;
      wrap.addEventListener('click', this.onInput);
    }
  }

  unbind() {
    if (this.watched) {
      this.watched.removeEventListener('input', this.onInput);
      this.watched.removeEventListener('change', this.onInput);
    }
    if (this.watchedWrap) this.watchedWrap.removeEventListener('click', this.onInput);
  }

  update() {
    const input = this.input;
    const qty = input ? Number(input.value) : NaN;
    this.rows.forEach((row) => {
      const min = Number(row.dataset.qtyMin);
      const maxRaw = row.dataset.qtyMax;
      const max = maxRaw === '' ? Infinity : Number(maxRaw);
      const hit = Number.isFinite(qty) && qty >= min && qty <= max;
      row.classList.toggle('is-current', hit);
    });
  }
}

if (!customElements.get('price-table-highlight')) {
  customElements.define('price-table-highlight', PriceTableHighlight);
}
